import { EmploymentStatusEnum, ResourceScheduleStatusEnum, Schedule } from "@/graphql/generated/graphql";
import { formatAddress, titleizeCamelCase } from "@/utils/helperFunctions";
import { InfoOutline } from "@mui/icons-material";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';
import { Grid, Tooltip, Typography } from "@mui/material";
import dayjs from "dayjs";
import { GridColDef } from "esseal-data-table";

const peopleRegisterColumns = (timeFormat: string): GridColDef<Schedule>[] =>
  [
    {
      field: "companyResource",
      headerName: "Name",
      width: 180,
      valueGetter: (row) => row.companyResource?.name ?? "No Resource Assigned",
      renderCell: ({ row }) => {
        if (row.companyResource?.user && row.companyResource.user.defaultEmploymentStatus === EmploymentStatusEnum.Pending) {
          return <Grid alignItems="center">
            {titleizeCamelCase(row.companyResource.name)}
            <Tooltip title="Employment Pending">
              <InfoOutline sx={{ ml: 1, fontSize: 16 }} color="disabled" />
            </Tooltip>
          </Grid>
          return
        }
        return row.companyResource ? `${titleizeCamelCase(row.companyResource.name)}` : "No Resource Assigned"
      }
    },
    {
      field: "startTime",
      headerName: "Check In",
      width: 180,
      filterable: false,
      renderCell: (row) => dayjs(row.value).format(timeFormat)
    },
    {
      field: "endTime",
      headerName: "Check Out",
      width: 180,
      filterable: false,
      renderCell: (row) => dayjs(row.value).format(timeFormat)
    },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      filterable: false,
      renderCell: ({ value }) => {
        if (value === ResourceScheduleStatusEnum.Scheduled)
          return <Tooltip title='Scheduled'>
            <CheckCircleOutlineIcon sx={{ marginTop: '8px' }} color='success' fontSize="small" />
          </Tooltip>
        if (value === ResourceScheduleStatusEnum.Dropped)
          return <Tooltip title='Dropped'>
            <CancelIcon sx={{ marginTop: '8px' }} color='error' fontSize="small" />
          </Tooltip>
        if (value === ResourceScheduleStatusEnum.Missed)
          return <Tooltip title='Missed'>
            <ErrorIcon sx={{ marginTop: '8px' }} color='error' fontSize="small" />
          </Tooltip>
        if (value === ResourceScheduleStatusEnum.Completed)
          return <Tooltip title='Completed'>
            <CheckCircleIcon sx={{ marginTop: '8px' }} color='success' fontSize="small" />
          </Tooltip>
      }
    },
    {
      field: "title",
      width: 180,
      headerName: "Role"
    },
    {
      field: "source",
      width: 180,
      headerName: "Source"
    },
    {
      field: "address",
      headerName: "Location",
      width: 180,
      valueGetter: (row) => row.address?.title ?? "Primary",
      renderCell: ({ row, value }) => <Tooltip title={formatAddress(row.address)}>
        <Typography variant="caption" noWrap sx={{ maxWidth: "400px" }}>{value}</Typography>
      </Tooltip>
    },
  ];

export default peopleRegisterColumns
